<!--begin::Body-->
<div class="kt-login__body">
	<!--begin::Signin-->
	<div class="kt-login__form">
		<div class="kt-login__title">
			<span><mat-icon>vpn_key</mat-icon></span>
			<h3>Mot de passe oublié ?</h3>
		</div>

		<div *ngIf="demandeRetour?.message !=''"
			 class="alert alert-solid-{{demandeRetour.ok ? 'success':'danger'}} alert-bold" role="alert">
			<div class="alert-text">
				<span>{{demandeRetour.message}}</span>
				<br>
				<a href="javascript:;" routerLink="/auth" class="kt-link kt-login__link-forgot">
					Retour à la page d'authentification
				</a>
			</div>
		</div>

		<form *ngIf="afficherForm" class="kt-form" [formGroup]="forgotPasswordForm" autocomplete="off">
			<div class="form-group">
				<mat-form-field>
					<mat-label>Email</mat-label>
					<input matInput type="email" placeholder="Email" formControlName="email" autocomplete="off"/>
					<mat-error *ngIf="isControlHasError('email','required')">
						<strong>Email invalide</strong>
					</mat-error>
				</mat-form-field>
			</div>
			<!--begin::Action-->
			<div class="kt-login__actions">

				<a href="javascript:;" routerLink="/auth" class="kt-link kt-login__link-forgot">
					Retour à la page d'authentification
				</a>
				<button [disabled]="loading" (click)="demanderChangementMotDePasse()" id="kt_login_signin_submit"
						class="btn btn-primary btn-elevate kt-login__btn-primary"
						[ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading}">
					Valider
				</button>
			</div>
			<!--end::Action-->
		</form>
	</div>
</div>

